import {ServiceTypeEnum} from '@/services/api-clients';

export function invoiceServiceTypeIconFilter(type: ServiceTypeEnum): string {
  switch(type) {
    case ServiceTypeEnum.Food: return 'mdi-moped';
    case ServiceTypeEnum.Taxi: return 'mdi-taxi';
  }
}
